const EVENTS = {
  CLOSE_MENU: 'ui.action.close_menu',
};

function dataEventBusMap(resourceName) {
  return {
    load: `data.${resourceName}.load`,
    success: `data.${resourceName}.success`,
    error: `data.${resourceName}.error`,
  };
}

export const API_EVENTS = {
  token: dataEventBusMap('token'),
};

export default EVENTS;
